export default __webpack_public_path__ + "static/media/icon_uesr.13e34068.svg";